// API Endpoints - Exact match to Flutter implementation
// Source: centrajob_frontend_college repositories

// Base URL getters
export const getAccountsBaseUrl = () => import.meta.env.VITE_ACCOUNTS_BASE_URL;
export const getCollegeBaseUrl = () => import.meta.env.VITE_COLLEGE_BASE_URL;
export const getCandidatesBaseUrl = () => import.meta.env.VITE_CANDIDATES_BASE_URL;
export const getAdminBaseUrl = () => import.meta.env.VITE_ADMIN_BASE_URL;
export const getNotificationBaseUrl = () => import.meta.env.VITE_NOTIFICATION_BASE_URL;
export const getEmployerBaseUrl = () => import.meta.env.VITE_EMPLOYER_BASE_URL;

// API Endpoints organized by service
export const API_ENDPOINTS = {
  // Account Service - Authentication & Password
  account: {
    login: '/api/Account/LogIn',
    sendOtp: '/api/Account/SendOTP',
    verifyOtp: '/api/Account/VerifyOTP',
    forgotPasswordRequest: '/api/Account/ForgotPasswordRequest',
    verifyForgotPasswordOtp: '/api/Account/VerifyForgetPassowrdOTP',
    forgotPasswordCheckOtpAndReset: '/api/Account/ForgotPasswordCheckOTPAndResetPassword',
    changePassword: '/api/Account/ChangePassword',
    captchaSiteVerify: '/api/Account/CaptchaSiteVerify',
    refreshToken: '/api/Account/RefreshToken',
    reLoginByRefreshToken: '/api/Account/ReLoginByRefreshToken',
  },

  // Admin Service - Universities, Colleges, Cities, etc.
  admin: {
    getCities: '/api/Admin/GetAllNewCities',
    getAddressByPincode: '/api/Admin/GetAddressByPincode',
    getAllUniversities: '/api/Admin/GetAllUniversities',
    getAllCollegesInUniversity: '/api/Admin/GetAllCollegesInUniversity',
    getAllCourses: '/api/Admin/GetAllCourses',
    getAllStreams: '/api/Admin/GetAllStreams',
    getAllGlobalCompanies: '/api/Admin/GetAllGlobalCompanies',
    getAllJobPositions: '/api/Admin/GetAllJobPositions',
    addDreamAndPastDriveCompanies: '/api/Admin/AddDreamAndPastDriveCompanies',
    getClaimsByCollegeUId: '/api/Admin/GetClaimsByCollegeUId',
    getDefaultPermissionsByType: '/api/Admin/GetDefaultPermissionsByType',
   
    getUserPermissionsByUserUId: '/api/Admin/GetUserPermissionsByUserUId',
    updateUserPermissions: '/api/Admin/UpdateUserPermissions',
    getAllFirstPageCards: '/api/Admin/GetAllFirstPageCards',
    getAllTotalCounts: '/api/Admin/GetAllTotalCollegesCandidatesCompaniesCountViaKey',
    getInvitedCollegeByUId: '/api/Admin/GetInvitedCollegeByUId',
  },

  // College Service - College Registration & Management
  college: {
    registerCollege: '/api/College/RegisterCollege',
    isCollegeNameExists: '/api/College/IsCollegeNameExits',
    isMobileAndEmailExists: '/api/College/IsMobileAndEmailExits',
    getCollegeDetailsByUId: '/api/College/GetCollegeDetailsByUId',
    getCollegeDetailsByUIdViaAuthKey: '/api/College/GetCollegeDetailsByUIdViaAuthKey',
    updateCollegeDetails: '/api/College/UpdateCollegeDetails',
    verifyCollege: '/api/College/VerifyCollege',
    uploadCollegeDocument: '/api/College/UploadCollegeDocument',
    deleteDocumentsFromBlob: '/api/College/DeleteDocumentsFromBlob',
    getAllColleges: '/api/College/GetAllColleges',
    getInvitedCollegeByUId: '/api/College/GetCollegeDetailsByUIdViaAuthKey',

    // Jobs for College
    getAllJobPostsForCollege: '/api/College/GetAllJobPostsForCollege',
    getAllJobApprovalForCollege: '/api/College/GetAllJobApprovalForCollege',
    approveOrRejectJobPost: '/api/College/ApproveOrRejectJobPostApprovalForCollege',
    approveOrRejectMultipleJobPost: '/api/College/ApproveOrRejectMultipleJobPostApprovalForCollege',
    getCompanyJobPostByUId: '/api/College/GetCompanyJobPostByUId',

    // Courses & Streams
    getCourseByCollegeUId: '/api/College/GetCourseByCollegeUId',
    getStreamsByCollegeUId: '/api/College/GetStreamsByCollegeUId',
    addCourse: '/api/College/AddCourse',
    updateCourse: '/api/College/UpdateCourse',
    deleteCourse: '/api/College/DeleteCourse',

    // Calendar Events
    getAllCalendarEvents: '/api/College/GetAllCalendarEvents',
    addCalendarEvent: '/api/College/AddCalendarEvent',

    // Candidate Invitation
    inviteCandidate: '/api/College/InviteCandidate',
    importCandidateForInvitation: '/api/College/ImportCandidateForInvitation',
    sendReminder: '/api/College/SendReminder',

    // Placement Coordinator
    getPlacementCoordinatorByUId: '/api/College/GetPlacementCoordinatorByUId',
    invitePlacementCoordinator: '/api/College/InvitePlacementCordinator',
    updatePlacementCoordinator: '/api/College/UpdatePlacementCoordinator',
    deletePlacementCoordinator: '/api/College/DeletePlacementCoordinator',
    getPlacementCoordinatorSettingByCollegeUId: '/api/College/GetPlacementCoordinatorSettingByCollegeUId',
    updatePlacementCoordinatorSetting: '/api/College/UpdatePlacementCoordinatorSetting',

    // Applications
    getApplicationDetails: '/api/College/GetApplicationDetails',
    getAllJobTitleForAppliedJobCandidate: '/api/College/GetAllJobTitleForAppliedJobCandidate',
  },

  // Candidate Service
  candidate: {
    getAllCandidates: '/api/Candidate/GetAllCandidates',
    getCandidateByUId: '/api/Candidate/GetCandidateByUId',
    updateCandidate: '/api/Candidate/UpdateCandidate',
    approveOrRejectCandidate: '/api/Candidate/ApproveOrRejectCandidate',
    approveRejectMultipleCandidate: '/api/Candidate/ApproveRejectMultipleCandidate',
    getAllAppliedJobCandidates: '/api/Candidate/GetAllAppliedJobCandidates',
    approveRejectCandidateJobApplication: '/api/Candidate/ApproveRejectCandidateJobApplication',
    approveRejectMultipleCandidateJobApplication: '/api/Candidate/ApproveRejectMultipleCandidateJobApplication',
    getAllCandidateStageTracking: '/api/Candidate/GetAllCandidateStageTracking',
    getMockInterviewByCandidateUId: '/api/Candidate/GetMockInterviewByCandiateUId',
    exportCandidates: '/api/Candidate/ExportCandidates',
    downloadDocument: '/api/Candidate/DownloadDocument',
    bulkApplyForJob: '/api/Candidate/BulkApplyForJob',
    getAllCandidateForBulkJobApply: '/api/Candidate/GetAllCandidateForBulkJobApply',
    extractCandidatesFromExcel: '/api/Candidate/ExtractCandidatesFromExcel',
    bulkApplyForJobByExcel: '/api/Candidate/BulkApplyForJobByExcel',
  },

  // Learning Material / Batch Service
  learningMaterial: {
    getAllInstructors: '/api/LearningMaterial/GetAllInstructors',
    addBatch: '/api/LearningMaterial/AddBatch',
    getBatchByUId: '/api/LearningMaterial/GetBatchByUId',
    getAllBatchCandidates: '/api/LearningMaterial/GetAllBatchCandidates',
    getAllBatches: '/api/LearningMaterial/GetAllBatches',
    getOverAllCountForBatchCandidatesInstructors: '/api/LearningMaterial/GetOverAllCountForBatchCandidatesInstructors',
    deleteBatch: '/api/LearningMaterial/DeleteBatch',
    updateBatch: '/api/LearningMaterial/UpdateBatch',
    addMultipleCandidatesInBatch: '/api/LearningMaterial/AddMultipleCandidatesInBatch',
    deleteCandidateInBatch: '/api/LearningMaterial/DeleteCandidateInBatch',
    getAllLanguageLevelTracking: '/api/LearningMaterial/GetAllLanguageLevelTrackingForCandidateByCandidateUID',
    addBatchLevel: '/api/learningmaterial/AddBatchLevel',
    getAllBatchLevels: '/api/learningmaterial/GetAllBatchLevels',
    deleteBatchLevelByUId: '/api/LearningMaterial/DeleteBatchLevelByUId',
    getAllLearningMaterial: '/api/LearningMaterial/GetAllLearningMaterial',
    publishLearningMaterial: '/api/LearningMaterial/PublishLearningMaterial',
    getLearningMaterialByUId: '/api/LearningMaterial/GetLearningMaterialByUId',
    updateLearningMaterial: '/api/LearningMaterial/UpdateLearningMaterial',
    deleteLearningMaterial: '/api/LearningMaterial/DeleteLearningMaterial',
    downloadDocument: '/api/Candidate/DownloadDocument',
    getAllStages: '/api/LearningMaterial/GetAllStages',
    getAllStagesInCollege: '/api/LearningMaterial/GetAllStagesInCollege',
    getStageInCollegeByUId: '/api/LearningMaterial/GetStageInCollegeByUId',
    addStageInCollege: '/api/LearningMaterial/AddStageInCollege',
    updateStageInCollege: '/api/LearningMaterial/UpdateStageInCollege',
    deleteStageInCollege: '/api/LearningMaterial/DeleteStageInCollege',
  },

  // Announcement Service
  announcement: {
    getAllAnnouncements: '/api/Announcement/GetAllAnnouncements',
    publishAnnouncement: '/api/Announcement/PublishAnnouncement',
    updateAnnouncement: '/api/Announcement/UpdateAnnouncement',
    getAnnouncementByUId: '/api/Announcement/GetAnnouncementByUId',
    deleteAnnouncement: '/api/Announcement/DeleteAnnouncement',
  },

  // Dashboard Service
  dashboard: {
    getJobCandidateApplicationForDashBoard: '/api/CollegeDashboard/GetJobCandidateApplicationForDashBoard',
    getAverageForPlacedCandidates: '/api/CollegeDashboard/GetAverageForPlacedCandidates',
    dashboardForPlacedStudents: '/api/CollegeDashboard/DashboardForPlacedStudents',
    getStreamWiseRegisteredCandidateCount: '/api/CollegeDashboard/GetStreamWiseRegisteredCandidateCount',
  },

  // Notification Service
  notification: {
    getAllNotifications: '/api/Notification/GetAllNotifications',
    saveDeviceToken: '/api/Notification/SaveDeviceToken',
    deleteDeviceToken: '/api/Notification/DeleteDeviceToken',
  },

  // Employer Service
  employer: {
    getAllUpcomingEvents: '/api/Employer/GetAllUpcomingEvents',
  },

  // Role Permission Service
  rolePermission: {
    getAllRoles: '/api/RolePermission/GetAllRoles',
  },
} as const;

